import React, { useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import {
  CHeader,
  CToggler,
  CHeaderBrand,
  CHeaderNav,
  CHeaderNavItem,
  CHeaderNavLink,
  CSubheader,
  CBreadcrumbRouter,
  CLink,CButton
} from '@coreui/react'
import CIcon from '@coreui/icons-react'

// routes config
import {routes} from '../routes';
import { 
  TheHeaderDropdown
}  from './index'

const TheHeader = () => {
  
  const dispatch = useDispatch()
  const sidebarShow = useSelector(state => state.sidebarShow)

  const toggleSidebar = () => {
    const val = [true, 'responsive'].includes(sidebarShow) ? false : 'responsive'
    dispatch({type: 'set', sidebarShow: val})
  }
  const [userSetting,setUserSetting] = useState(JSON.parse(localStorage.getItem('user_setting')));
  const toggleSidebarMobile = () => {
    const val = [false, 'responsive'].includes(sidebarShow) ? true : 'responsive'
    dispatch({type: 'set', sidebarShow: val})
  }
 const logout = () => {
    let url = localStorage.getItem('role') == 'admin' ? "/login/admin" : '/login/user';
    localStorage.clear();
    window.location.replace(url);
  }

  return (
    <CHeader withSubheader>
      <CToggler
        inHeader
        className="ml-md-3 d-lg-none"
        onClick={toggleSidebarMobile}
      />
      <CToggler
        inHeader
        className="ml-3 d-md-down-none"
        onClick={toggleSidebar}
      />
      <CHeaderBrand className="mx-auto d-lg-none fw-bolder" to="/" style={{"fontWeight": "700 !important"}}>
       {userSetting?.app_name}
      </CHeaderBrand>

      <CHeaderNav className="d-md-down-none mr-auto">
        <CHeaderNavItem className="px-3" >
          <CHeaderNavLink to="/dashboard">Dashboard</CHeaderNavLink>
        </CHeaderNavItem>
      </CHeaderNav>

      <CHeaderNav className="px-3">
        
      <TheHeaderDropdown/>
        <CLink className="c-subheader-nav-link btn btn-warning text-dark btn-sm no-print" 
              aria-current="page" 
              to="/user-management/user/change-password">
                Change Password
              </CLink>
        <CButton onClick={logout} className="no-print" ><CIcon name="cil-lock-locked" className="mfe-2" /> Logout</CButton>
      </CHeaderNav>

      <CSubheader className="px-3 justify-content-between">
        <CBreadcrumbRouter 
          className="border-0 c-subheader-nav m-0 px-0 px-md-3 no-print" 
          routes={routes} 
        />
          <div className="d-md-down-none mfe-2 c-subheader-nav">
            <CLink 
              className="c-subheader-nav-link" 
              aria-current="page" 
              to="/dashboard"
            >
              <CIcon name="cil-graph" alt="Dashboard" />&nbsp;Dashboard
            </CLink>
          </div>
      </CSubheader>
      
    </CHeader>
  )
  
}

export default TheHeader
